import React from 'react';
import PropTypes from 'prop-types';
import Notification from 'erpcore/components/Notification';

/**
 * Notification Manager - Divisions Notifications
 * @return {Node} Returns Notification component
 */
// eslint-disable-next-line no-unused-vars
const CustomerNotifications = ({ identifier, code, detail, notificationData }) => {
    switch (code) {
        case 'company.itemSuccessfulyCreated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Customer successfully created!"
                    type="success"
                    expire="3500"
                />
            );
        case 'company.itemSuccessfulyUpdated':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Customer successfully updated!"
                    type="success"
                    expire="3500"
                />
            );
        case 'company.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Customer successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        case 'companies.itemSuccessfulyRemoved':
            return (
                <Notification
                    identifier={identifier}
                    title="Success"
                    text="Customers successfully deleted!"
                    type="success"
                    expire="3500"
                />
            );
        default:
            return null;
    }
};

CustomerNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
    notificationData: null
};

CustomerNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
    notificationData: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
};

export default CustomerNotifications;
